import Layout from '@/views/layout/Index'

export const SystemRouter =
	[{
	path: '/system',
	name: 'system',
	component: Layout,
	meta: { title: '系统管理', icon: 'fa-dashboard' },
	children: [
		{
			path: '',
			component: () => import('@/views/dashboard/index'),
			name: 'index',
			meta: { title: '首页', icon: 'fa-dashboard' },
			hidden: true
		},
		{
			path: 'user/list',
			component: () => import('@/views/system/userList'),
			name: 'sys-user',
			meta: { title: '用户列表', icon: 'fa-user-plus' }
		},
		{
			path: 'user/edit/:userId',
			hidden: true,
			component: () => import('@/views/system/userSave'),
			name: 'sys-user-edit',
			meta: { title: '用户修改', icon: 'fa-user', isEdit: true, auth: 'none' }
		},
		{
			path: 'unit/list',
			component: () => import('@/views/system/unit'),
			name: 'sys-unit',
			meta: { title: '机构管理', icon: 'fa-sitemap' }
		},
		{
			path: 'resource/list',
			component: () => import('@views/system/resource'),
			name: 'sys-resource',
			meta: { title: '资源列表', icon: 'fa-paw' }
		},
		{
			path: 'role/list',
			component: () => import('@views/system/role'),
			name: 'sys-role',
			meta: { title: '角色列表', icon: 'fa-futbol-o' }
		},
		{
			path: 'auth/list',
			component: () => import('@/views/system/authList'),
			name: 'sys-auth',
			meta: { title: '授权列表', icon: 'fa-leaf' }
		},
		{
			path: 'job/list',
			component: () => import('@views/system/job'),
			name: 'sys-job',
			meta: { title: '职务列表', icon: 'fa-anchor' }
		},
		{
			path: 'group/list',
			component: () => import('@views/system/group'),
			name: 'sys-group',
			meta: { title: '分组列表', icon: 'fa-group' }
		}
	]
}
]
